export const schemeConstants = {
  apollo: 1,
  APOLLO: 1,
  apolo: 1,
  APOLO: 1,
  Apolo: 1,
  CEAT: 2,
  ceat: 2,
  Ceat: 2,
  mrf: 3,
  MRF: 3,
  Mrf: 3,
  bridgestone: 4,
  Bridgestone: 4,
  BridgeStone: 4,
  BRIDGESTONE: 4,
  "bridge stone": 4,
  "bridge-stone": 4,
  "Bridge Stone": 4,
  "Bridge-Stone": 4,
  "Bridge stone": 4,
  "Bridge-stone": 4,
  "BRIDGE STONE": 4,
  YOKOHAMA: 5,
  yokohama: 5,
  Yokohama: 5,
  Yokoohama: 5,
};
